import { z } from 'zod';
import { optionalUuidString, requiredUuidString } from '../zod-helpers/index.js';
export const updateUserInputSchema = z.object({
    departmentId: optionalUuidString('Invalid department selection.').optional().nullable(),
    // Nullable to match UpdateUserInputValue.roleIds' GraphQL-nullable-list type -- the resolver
    // already treats an explicit null the same as omitted (see update-user.ts), so this schema
    // must actually let null through rather than rejecting it before the resolver sees it.
    roleIds: z
        .array(requiredUuidString('Role id is required.', 'Invalid role id.'))
        .optional()
        .nullable(),
    // Same nullable-list reasoning as roleIds above.
    locationGroupIds: z
        .array(requiredUuidString('Location group id is required.', 'Invalid location group id.'))
        .optional()
        .nullable(),
    // Same nullable-list reasoning as roleIds above.
    brandIds: z
        .array(requiredUuidString('Brand id is required.', 'Invalid brand id.'))
        .optional()
        .nullable(),
    // Same nullable-list reasoning as roleIds above, plus a cap since StateConst is bounded (US states + territories).
    stateIds: z
        .array(requiredUuidString('State id is required.', 'Invalid state id.'))
        .max(60, 'Too many state ids.')
        .optional()
        .nullable(),
    defaultLocationGroupId: optionalUuidString('Invalid location group selection.')
        .optional()
        .nullable(),
});
//# sourceMappingURL=update-input.js.map